import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { typeSpecificProps } from "helpers/reports";
import { ymEvent } from "helpers/system";
import { matchSorter } from "match-sorter";
import React from "react";
import CommonReport from "./commonReport";

export default class PlanPointIntersectionsReport extends CommonReport {
    componentDidMount() {
        this.setState({ tableDefaultProps: this.tableDefaultProps() });
        ymEvent("PlanPointIntersectionsReportOpened");
    }

    extractColumns = () => {
        return [
            {
                Header: "Заявка",
                accessor: "id",
                filterable: true,
                filterMethod: (filter, row) =>
                    row._groupedByPivot ||
                    matchSorter([(row.bidId || "").toString()], filter.value, {
                        threshold: matchSorter.rankings.CONTAINS,
                    }).length !== 0,
                Cell: ({ value }) => (
                    <a data-test-id="bid" href={paths.bidShow("bid", value)} target="_blank" rel="noopener noreferrer">
                        {value}
                    </a>
                ),
                Aggregated: () => "",
            },
            {
                Header: "Машина",
                accessor: "car",
                Aggregated: () => "",
                filterable: true,
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value) {
                        return rows;
                    }
                    return rows.filter(
                        (row) =>
                            matchSorter([row.values.car], filterValue.value, {
                                threshold: matchSorter.rankings.CONTAINS,
                            }).length !== 0,
                    );
                },
                Cell: ({ value, row: { original } }) => {
                    if (!original.carId) {
                        return "—";
                    }
                    return (
                        <a
                            data-test-id="car"
                            href={paths.trucksShow(original.carId)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {value}
                        </a>
                    );
                },
            },
            {
                Header: "Водитель",
                accessor: "driver",
                Aggregated: () => "",
                filterable: true,
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value) {
                        return rows;
                    }
                    return rows.filter(
                        (row) =>
                            matchSorter([row.values.driver], filterValue.value, {
                                threshold: matchSorter.rankings.CONTAINS,
                            }).length !== 0,
                    );
                },
                Cell: ({ value, row: { original } }) => {
                    if (!original.driverId) {
                        return "—";
                    }
                    return (
                        <a
                            data-test-id="driver"
                            href={paths.driversShow(original.driverId)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {value}
                        </a>
                    );
                },
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                Cell: ({ value }) => <div data-test-id="created-at">{dateTimeToView(value)}</div>,
                Aggregated: () => "",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
            },
            {
                Header: "Первая точка заявки",
                accessor: "firstBidPoint.geozone",
                Cell: ({ value }) => <div data-test-id="first-point-geozone">{value}</div>,
                Aggregated: () => "",
                ...typeSpecificProps({}),
            },
            {
                Header: "Последняя точка заявки",
                accessor: "lastBidPoint.geozone",
                Cell: ({ value }) => <div data-test-id="last-point-geozone">{value}</div>,
                Aggregated: () => "",
                ...typeSpecificProps({}),
            },
            {
                Header: "Плановая дата начала заявки",
                accessor: "firstBidPoint.planEnterDateOffset",
                Cell: ({ value }) => (
                    <div data-test-id="first-point-plan-enter-date">
                        {dateTimeToView(value, "DD.MM.YYYY HH:mm (Z)")}
                    </div>
                ),
                Aggregated: () => "",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
            },
            {
                Header: "Плановая дата завершения заявки",
                accessor: "lastBidPoint.planEnterDateOffset",
                Cell: ({ value }) => (
                    <div data-test-id="last-point-plan-enter-date">{dateTimeToView(value, "DD.MM.YYYY HH:mm (Z)")}</div>
                ),
                Aggregated: () => "",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
            },
        ];
    };
}
